export default __webpack_public_path__ + "static/media/dinner5.ccf85964.jpeg";